import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import InputField from 'dashboard/components/FormControls/InputField';
import Form from 'dashboard/layouts/FormLayout/Form';
import Button from 'design-system/components/Button';
import { isMaxLength, isRequired, withMessage } from 'lib/utils/formValidation';

const StyledButton = styled(Button)`
  margin-top: ${SPACINGS.base * 3}px;
  width: 48%;
`;

const ButtonContainer = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const validate = {
  name: [
    withMessage('Please enter a name', isRequired),
    withMessage('Please limit name to 255 characters', isMaxLength(255)),
  ],
};

interface FormAddAccountStatusProps {
  closeModal: () => void;
}

const FormAddAccountStatus = ({
  handleSubmit,
  submitting,
  pristine,
  closeModal,
}: FormAddAccountStatusProps &
  InjectedFormProps<FormAddAccountStatusData, FormAddAccountStatusProps>) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Field
        label='Name (required)'
        name='name'
        disabled={submitting}
        component={InputField}
        data-test='add-account-status-form__name'
        validate={validate.name}
      />
      <ButtonContainer>
        <StyledButton
          id='add-account-status__cancel'
          name='add-account-status-form__close'
          type='button'
          onClick={closeModal}
          data-test='add-account-status-form__close'
          variant='basic'
        >
          Cancel
        </StyledButton>
        <StyledButton
          name='add-account-status-form__submit'
          type='submit'
          disabled={pristine}
          value='Submit'
          data-test='add-account-status-form__submit'
        >
          Add Account Status
        </StyledButton>
      </ButtonContainer>
    </Form>
  );
};

export interface FormAddAccountStatusData {
  name: string;
}

export default reduxForm<FormAddAccountStatusData, FormAddAccountStatusProps>({
  form: 'addAccountStatus',
})(FormAddAccountStatus);
